// extracted by mini-css-extract-plugin
export default {"ingredient":"burger-ingredient_ingredient__jYLv-","ingredientLink":"burger-ingredient_ingredientLink__bsp8v","ingredientsName":"burger-ingredient_ingredientsName__gErIl"};